import { useMemo } from 'react';
import {
  Box,
  Grid,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, ChartOptions } from 'chart.js';
import { formatCurrency } from '@roc/ui/utils';
import { Paper } from '@roc/ui';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

const useStyles = makeStyles(theme => ({
  container: {
    padding: 32,
  },
  paper: {
    padding: 24,
  },
  graphContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  graph: {
    position: 'relative',
    width: 300
  },
  totalValue: {
    position: 'absolute',
    top: '100px',
    width: '100%',
    textAlign: 'center',
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '40px',
  },
  totalLbl: {
    position: 'absolute',
    top: '135px',
    width: '100%',
    textAlign: 'center',
    color: '#71717A',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0%',
  }
}));

export const LoanValuesChartColor = {
  chRemaining: '#00A8DF',
  chReimbursedToDate: '#01335C',
}

export const LoanValuesChartOnly = ({ chRemaining, chReimbursedToDate }) => {
  const classes = useStyles();
  const total = useMemo(() => formatCurrency(chReimbursedToDate + chRemaining, 0), [chRemaining, chReimbursedToDate]);

  const data = {
    labels: ['Construction Holdback Reimbursed to Date', 'Construction Holdback Remaining'],
    datasets: [
      {
        label: 'Construction Holdback',
        data: [chReimbursedToDate, chRemaining],
        backgroundColor: [
          LoanValuesChartColor.chReimbursedToDate,
          LoanValuesChartColor.chRemaining,
        ],
        borderColor: [
          LoanValuesChartColor.chReimbursedToDate,
          LoanValuesChartColor.chRemaining,
        ],
        borderWidth: 0,
        spacing: 1,
      },
    ],
  };
  const options: ChartOptions<'doughnut'> = {
    cutout: 95,
    radius: "85%",
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        align: 'start'
      },
      tooltip: {
        callbacks: {
          //@ts-ignore
          label: function (tooltipItem, data) {
            const label = tooltipItem.label || '';
            return label;
          },
          //@ts-ignore
          afterLabel: function (tooltipItem, data) {
            let afterLabel = '';
            if (tooltipItem.parsed !== null) {
              afterLabel = formatCurrency(tooltipItem.parsed);
            }
            return afterLabel;
          }
        },
        titleFontSize: 16,
        titleFontColor: '#0066ff',
        bodyFontColor: '#000',
        bodyFontSize: 16,
        displayColors: false,
      }
    },
  };
  return (
    <>
      <Typography className={classes.totalValue}>
        {total}
      </Typography>
      <Typography className={classes.totalLbl}>
        Total
      </Typography>
      <Doughnut data={data} options={options} />
    </>
  )
};

const LoanValuesChart = ({ chRemaining, chReimbursedToDate, borderType = undefined }) => {
  const classes = useStyles();
  return (
    <Grid item xs={12}>
      <Paper title="Construction Holdback" borderType={borderType}>
        <Box className={classes.graphContainer}>
          <Box className={classes.graph}>
            <LoanValuesChartOnly chRemaining={chRemaining} chReimbursedToDate={chReimbursedToDate} />
          </Box>
        </Box>
      </Paper>
    </Grid>
  )
};

export default LoanValuesChart;
